import React, {useEffect, useState} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Col } from "atomize";
import styled from "styled-components";
import {apiGet} from "../../../Api";
import {baseUrl} from "../../../Constants/constants";
import Skeleton from "react-loading-skeleton";
import ReactModal from 'react-modal';
import {useScrollPosition} from "../../../utils/getScrollPosition";
import {ReactComponent as CloseIcon} from "../../../Assets/Icons/close.svg";


const Wrapper = styled(Col)`
  margin-top: 2rem;
`;

const Name = styled.h4`
  color: ${theme.colors.primary};	
  font-family: Inter;	
  font-size: 20px;	
  font-weight: 600;	
  line-height: 32px;	
  text-align: center;
  margin-top: 1rem;
  transition: color .25s ease-in-out;
  &:hover {
    color: ${theme.colors.secondary};	
  }
`;

const Title = styled.p`
  color: #8A94A6;	
  font-family: Inter;	
  font-size: 14px;	
  line-height: 20px;	
  text-align: center;
  margin-top: .5rem;
`;

const Image = styled(Div)`
  justify-content: center;
  display: flex;
  img, span {
    width: 60px;
    height: 60px;
    box-shadow: 0 0 1px 0 rgba(10,22,70,0.06), 0 6px 6px -1px rgba(10,22,70,0.1);
    border-radius: 100%;
  }
  &.large {
    margin-right: 1rem;
    img, span {
      width: 100px;
      height: 100px;
    }
  }
`;

const CloseButton = styled.a`
  position: absolute;
  padding: 1rem;
  top: .5rem;
  right: .5rem;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  
  .meta {
    h2 {
      color: #0A1F44;	
      font-family: Inter;	
      font-size: 20px;	
      font-weight: 600;	
      line-height: 32px;
    }
    p {
      color: #8A94A6;	
      font-family: Inter;	
      font-size: 14px;	
      line-height: 20px;	
    }
  }
`;

const ModalBody = styled.div`
   margin-top: 2rem;
   p {
    color: #4E5D78;	
    font-family: Inter;	
    font-size: 14px;	
    line-height: 24px;
    margin-bottom: 1rem;
   }
`

function getParent() {
  return document.querySelector('#root');
}

function PersonAvatar(props) {
  const [data, setData] = React.useState({});
  ReactModal.setAppElement('#main');
  const [open, setOpen] = useState(false);

  function closeModal() {
    setOpen(false);
  }

  useScrollPosition(({ prevPos, currPos }) => {
    if (open) {
      if ( Math.abs(prevPos.y - currPos.y) > 50 ) {
        setOpen(false)
      }
    }
  }, [open]);

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`user/user/${props.person.id}?include=user_picture&jsonapi_include=1`);
      setData(result.data.data);
    }

    fetchData();
  }, []);

  return (
    <Wrapper
      size={{ xs: '12', sm: '12', md: '4', lg: '3' }}
    >
      <Image>
        { data.user_picture && data.user_picture.uri ?
        <img alt={data.name } src={ baseUrl + data.user_picture.uri.url } /> :
        <Skeleton circle={true} />
        }
      </Image>
      <a
        href={`#${data.name}`}
        onClick={ (e)=> {
          e.preventDefault();
          setOpen(true)
        }}
      >
        <Name>
          { data.name || <Skeleton/>}
        </Name>
      </a>
      <Title>
        { data.field_title || <Skeleton/>}
      </Title>
      <ReactModal
        isOpen={open}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => closeModal()}
        parentSelector={getParent}
        closeTimeoutMS={250}
        data={{
          background: "green"
        }}
      >
        <CloseButton
          aria-label={'close'}
          tabIndex={0}
          onClick={() => closeModal() }
        >
          <CloseIcon/>
        </CloseButton>
        <ModalHeader>
          <Image className={'large'} >
            { data.user_picture && data.user_picture.uri ?
              <img alt={data.name } src={ baseUrl + data.user_picture.uri.url } /> :
              <Skeleton circle={true} />
            }
          </Image>
          <div className={'meta'}>
            <h2>{ data.name || <Skeleton/>}</h2>
            <p>
              { data.field_title || <Skeleton/>}
            </p>
          </div>
        </ModalHeader>
        { data.field_biography &&
          <ModalBody
            dangerouslySetInnerHTML={{ __html: data.field_biography.value}}
          />
        }
      </ReactModal>
    </Wrapper>
  )
}

export default PersonAvatar
